import { action, makeObservable, observable } from 'mobx';

import { IMediaPermissions } from '@gem/call/CallStore/Call.types';
import { CallProviderType, ICallInfo, IWaitingRoomMember } from '@gem/call/Model/callModel.types';

import { Calls } from '../Calls';
import { ICallConstructorParams } from './MainCall.types';

export class MainCall {
  groupId: string | null = null;
  @observable channelId: string | null = null;
  providerType: CallProviderType;
  isUnauthorizedCall = false;
  calls: Calls;
  myId: string;
  isInitiator: boolean;
  initialMedia = {
    withVideo: false,
    withAudio: false,
  };
  mediaPermissions: IMediaPermissions | null = null;
  @observable deleteCallHandler: (() => Promise<void>) | null = null;
  initialDevicesIds: {
    audioinput: string | null;
    audiooutput: string | null;
    videoinput: string | null;
  };
  waitingRoomMembers?: IWaitingRoomMember[] = [];
  isWaitingRoomEnabled?: boolean = false;
  withoutTimer = false;
  isGuestsAllowed = false;
  @observable callInfo: ICallInfo;
  @observable readyToStart = false;
  @observable isStarted = false;
  @observable startTs: number | null = null;
  constructor(params: ICallConstructorParams) {
    makeObservable(this);
    const { groupId, channelId, providerType, isUnauthorizedCall = false, myId, calls } = params;
    this.myId = myId;
    this.providerType = providerType;
    this.groupId = groupId || null;
    this.channelId = channelId || null;
    this.isUnauthorizedCall = isUnauthorizedCall;
    this.calls = calls;
    this.initialMedia = params.initialMedia;
    this.withoutTimer = params.withoutTimer;
    this.initialDevicesIds = params.initialDevicesIds;
    this.waitingRoomMembers = params.waitingRoomMembers;
    this.isWaitingRoomEnabled = params.isWaitingRoomEnabled;
    this.isGuestsAllowed = params.isGuestsAllowed || false;
    this.mediaPermissions = params.mediaPermissions || null;
  }

  async delete(): Promise<void> {
    if (this.deleteCallHandler) {
      await this.deleteCallHandler();
    }
  }

  @action
  setStarted(isStarted: boolean): void {
    this.isStarted = isStarted;
  }

  @action
  setReadyToStart(props: { callInfo: ICallInfo; isInitiator: boolean }): void {
    this.callInfo = props.callInfo;
    this.isInitiator = props.isInitiator;
    this.channelId = props.callInfo.channelId;
    if (props.callInfo.groupId) {
      this.groupId = props.callInfo.groupId;
    }
    this.readyToStart = true;
  }

  @action
  setStartTs(startTs: number): void {
    this.startTs = startTs;
  }

  @action
  setDeleteCallHandler(handler: (() => Promise<void>) | null): void {
    this.deleteCallHandler = handler;
  }

  @action
  setChannelId(channelId: string): void {
    this.channelId = channelId;
  }
}
